import React, { useEffect, useState } from "react";
import Grid from '@mui/material/Grid2';
import { useTranslation } from "react-i18next";
import Button from "@common/components/Button";
import Section from "@pages/Dashboard/WidgetEdit/FilterPanel/FilterSections/Section";
import RightDrawer from "@common/components/RightDrawer";
import { participantsFilters } from "..";

type FiltersDrawerProps = {
  open: boolean;
  onClose: Function;
  participantFilter: string;
  setParticipantFilter: (value: string) => void;
};

const FiltersDrawer = (props: FiltersDrawerProps) => {
  const { open, onClose, participantFilter, setParticipantFilter } = props;
  const { t } = useTranslation();
  const [tmpValue, setTmpValue] = useState<string>(participantFilter);

  useEffect(() => setTmpValue(participantFilter), [participantFilter]);

  return (
    <RightDrawer
      open={open}
      onClose={() => {
        setParticipantFilter(tmpValue);
        onClose();
      }}
      title={t("Add filters ({{ COUNTER }})", {
        COUNTER: tmpValue === "" ? 0 : 1,
      })}
      closeButton={
        <Grid
          sx={(theme) => ({
            "&>.MuiButton-root": { marginRight: theme.spacing(1) },
          })}>
          <Button
            color="white"
            onClick={() => {
              setParticipantFilter(tmpValue);
              onClose();
            }}
          >
            Filter
          </Button>
          <Button
            color="greyed"
            variant="outlined"
            onClick={() => {
              setTmpValue("");
              setParticipantFilter("");
            }}
          >
            Clear
          </Button>
          <Button color="greyed" variant="outlined" onClick={() => onClose()}>
            Cancel
          </Button>
        </Grid>
      }
    >
      <Grid container direction="column" wrap="nowrap" sx={{ width: '100%', px: "1rem" }}>
        <Section title={"Participants"} subSection>
          {participantsFilters.map((label) => (
            <Button
              key={label}
              chip
              active={tmpValue === label}
              onClick={() => setTmpValue(tmpValue === label ? "" : label)}
              activeColor="white"
            >
              {t(label)}
            </Button>
          ))}
        </Section>
      </Grid>
    </RightDrawer>
  );
};

export default FiltersDrawer;
